import { useEffect, useState } from "react";

import { Helmet } from "react-helmet";
import ArtistList from "../components/artist/artistList";
import Loader from "../components/loader";
import SearchBar from "../components/searchBar";
import { useAppContext } from "../context/appContext";
import { ArtistResponseDTOMin } from "../openapi-generated-client";
import "./artists.css";
import Checkbox from "../components/checkbox";
import SearchBarWithDropdown from "../components/searchBarWithDropdown";

export default function ArtistsPage() {

    const [alsoContributors, setAlsoContributors] = useState(false);

    const [search, setSearch] = useState("");

    const {artistController} = useAppContext();

    const [data, setData] = useState<Array<ArtistResponseDTOMin>>();

    async function fetchArtists() {
        if(alsoContributors) {
            setData((await artistController.getArtistsAlsoContributors()).data);
        }else {
            setData((await artistController.getArtists()).data);
        }
    }

    useEffect(() => {
        fetchArtists();
    }, [alsoContributors]);

    if(data == undefined) {
        return <Loader/>;
    }

    return <div className="page keep-margin minHeight100 artists">
        <Helmet>
            <title>Artists | Txoria</title>
        </Helmet>

        <SearchBarWithDropdown search={search} setSearch={setSearch} dropdown={{
            prefix: "Show: ",
            options: ["Composer", "Composer & Contributor"],
            selectedOption: alsoContributors ? 1 : 0,
            setSelectedOption: function (id: number): void {
                setAlsoContributors(id === 1);
            }
        }}/>
        <ArtistList clickUrl="/artists" searchQuery={search} artists={data}/>
    </div>
}